export default "Relamping LED BAT-EQ-127 — Éclairage haute efficacité tertiaire | Solution Éco France";
